import { BaseSettings } from '../../common/component-settings/base-settings.model';
import { ActionItemResponse } from '../interfaces/action-item.interface';
import { TranslateParam } from '../../common/interfaces';


export class MyActionCenterModalComponentSettings extends BaseSettings {
    actionsItems: ActionItemResponse[];
    documentStates: any[] = [];
    adminToken: string;
    defaultrecordId: number;
    acceptClicked: boolean;
    skipClicked: boolean;
    impersonatedUser: boolean;
    translateParams: TranslateParam;
}
